import React, {useEffect, useState} from "react";
import HomePageEditor from "@/components/homePage/HomePageEditor";
import Layout from "@/layout/Layout";
import MButton from "@/components/atom/MButton";
import {useHistory} from "react-router";
import globalStyle from '@/styles/Global.scss'
import {Photo} from "@/entity/Photo";
import {addPhoto, getPhotos} from "@/api/photo";

const EditHomePage = () => {
  const history = useHistory()
  const [photo, setPhoto] = useState(new Photo({}))

  useEffect(() => {
    (async () => {
      const photos = await getPhotos()
      const lastPhoto = photos.pop();
      if (lastPhoto) {
        setPhoto({...photo, displayType: lastPhoto.displayType });
      }
    })()
  }, [])

  const save = async () => {
    await addPhoto({photo})
    history.push(`/homePage/edit`)
  }

  const goBack = () => {
    history.push(`/homePage/edit`)
  }

  const onChange = (photo) => {
    setPhoto(photo)
  }

  const onFileUpload = async (temporaryFile) => {
    setPhoto(new Photo({...photo, tmpFileId: temporaryFile.id}))
  }

  return (
    <>
      <Layout title={'ホームページ'}>
        <div>
          <HomePageEditor photo={photo} updatePhoto={onChange} onFileUpload={ onFileUpload }/>
        </div>
        <div className={globalStyle.attribute}>
          <MButton image={'hozon.png'} value={'保存'} onClick={save}></MButton>
          <MButton image={'back.png'} value={'戻る'} onClick={goBack}></MButton>
        </div>
      </Layout>
    </>
  )
}

export default EditHomePage
